import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'

import ThemeConsumer from 'embed/components/ThemeConsumer'

const styles = require('../styles')

interface Props {
  className?: string
}

const Spinner: React.SFC<Props> = ({ className }) => (
  <ThemeConsumer>
    {({ ctaStyles }) => (
      <div
        className={classnames(
          styles.spinner,
          css`
            border-left-color: ${ctaStyles?.backgroundColor};
          `,
          className,
        )}
      />
    )}
  </ThemeConsumer>
)

export default Spinner
